const DRAG_TYPES = {
  TREEITEM: 'treeitem',
};

export default DRAG_TYPES;